import { signal } from "@preact/signals-react";

export const invalidFilterValues = signal([]);
export const showFilterValuesWithoutParentDialog = signal(false);
export const pendingCsvData = signal(null);
export const showInvalidListFormatDialog = signal(false);
